import passwordAxios from './passwordAxios'

export const recover = (username) => {
  return passwordAxios.post(`/recover`, username)
}

export const profileRecover = (username) => {
  return passwordAxios.post(`/profileRecover`, username)
}

export const change = (password) => {
  return passwordAxios.post(`/change`, password)
}